module.exports = __webpack_public_path__ + "static/media/ascentarc-1.8176c00e.jpg";